export const defaultOption = {
    "Sub Account Permissions": {
        "manage_agents":[
            {
                label: "AI Agents & Related Menus",
                name: "agents_allowed",
                description: "Enable Agents to show in menu",
                type: "Switch",
            },
            {
                label: "Agents",
                name: "assistant_allowed",
                description: "Enable Agents to show in menu",
                type: "Switch",
            },
            {
                label: "Knowledge Base",
                name: "kb_allowed",
                description: "Enable Knowledge Base to show in menu",
                type: "Switch",
            },
            /* {
                label: "Phone Numbers",
                name: "create_number",
                description: "Enable Contact to show in menu",
                type: "Switch",
            }, */
            {
                label: "Custom Actions",
                name: "custom_actions_allowed",
                description: "Enable Custom Actions to show in menu",
                type: "Switch",
            },
            // {
            //     label: "POST Webhooks ",
            //     name: "post_webhooks_allowed",
            //     description: "Enable POST Webhooks to show in menu",
            //     type: "Switch",
            // },
            {
                label: "Web Widgets",
                name: "widgets_allowed",
                description: "Enable Web Widgets to show in menu",
                type: "Switch",
            },
            {
                label: "Integrations",
                name: "integrations_allowed",
                description: "Enable Integration to show in menu",
                type: "Switch",
            },
            {
                label: "Knowledge ",
                name: "knb_allowed",
                description: "Enable Knowledge Base to show in menu",
                type: "Switch",
            },
        ],
        "manage_contacts":[
            // {
            //     label: "AI Agents",
            //     name: "assistant_allowed",
            //     description: "Enable Contact to show in menu",
            //     type: "Switch",
            // },
            {
                label: "Leads/Outbound Calling",
                name: "contact_allowed",
                description: "Enable Lead to show in menu",
                type: "Switch",
            },
            {
                label: "Outbound Campaigns",
                name: "campaign_allowed",
                description: "Enable campaign to show in menu",
                type: "Switch",
            },
        
            {
                label: "Outbound Automation",
                name: "automation_allowed",
                description: "Enable automation to show in menu",
                type: "Switch",
            },
        {
            label: "Custom Fields",
            name: "custom_fields_allowed",
            description: "Enable customfields to show in menu",
            type: "Switch",
        },
        {
            label: "Import / Export",
            name: "import_export_allowed",
            description: "Enable import/export to show in menu",
            type: "Switch",
        },
        {
            label: "Webhook",
            name: "webhook_allowed",
            description: "Enable webhook to show in menu",
            type: "Switch",
        },
        ],
        // "manage_knowledge":[
        //     {
        //         label: "Knowledge ", // Base
        //         name: "knb_allowed",
        //         description: "Enable Knowledge Base to show in menu",
        //         type: "Switch",
        //     },
        // ],
        "manage_insights":[
            {
                label: "Knowledge ", // Base
                name: "kb_allowed",
                description: "Enable Knowledge Base to show in menu",
                type: "Switch",
            },
            /* {
                label: "Phone Numbers",
                name: "create_number",
                description: "Enable Contact to show in menu",
                type: "Switch",
            }, */
            {
                label: "Analytics",
                name: "insights_allowed",
                description: "Enable Contact to show in menu",
                type: "Switch",
            },
            {
                label: "Call Volume",
                name: "calls_volume_enabled",
                description: "",
                type: "Switch",
            },
            {
                label: "Goal Conversion",
                name: "won_lost_enabled",
                description: "",
                type: "Switch",
            },
            // {
            //     label: "Timing Analysis",
            //     name: "duration_enabled",
            //     description: "",
            //     type: "Switch",
            // },
            // {
            //     label: "Heat Map",
            //     name: "heat_map_enabled",
            //     description: "",
            //     type: "Switch",
            // },

            // {
            //     label: "A/B Testing",
            //     name: "ab_testing_enabled",
            //     description: "",
            //     type: "Switch",
            // },
            {
                label: "Call Details",
                name: "call_logs_enabled",
                description: "",
                type: "Switch",
            },
           
        ],
    },
    "Client Permissions" : {
        "Agent Settings": [
            {
                label: "Allow Agent Creation",
                name: "allowCreateAgents",
                description: "Allow creation of new agents",
                type: "Switch",
            },
            {
                label: "Allow Agent Duplication",
                name: "allowDuplicateAgents",
                description: "Allow duplication of existing agents",
                type: "Switch",
            },
            {
                label: "Allow Agent Deletion",
                name: "allowDeleteAgents",
                description: "Allow deletion of agents",
                type: "Switch",
            },
            {
                label: "Allow editing and publishing of agents",
                name: "allowPublishAgents",
                description: "Allow editing and publishing of agents",
                type: "Switch",
            },
            {
                label: "Show Agent Profile Settings",
                name: "showAgentProfileSettings",
                description: "Show agent profile settings",
                type: "Switch",
            },
            {
                label: "Show Agent Prompt Settings",
                name: "showAgentRoleSettings",
                description: "Show agent prompt settings",
                type: "Switch",
            },
            {
                label: "Show Agent Action Settings",
                name: "showAgentActionSettings",
                description: "Show agent action settings",
                type: "Switch",
            },
            {
                label: "Show agent deploy settings",
                name: "showAgentDeploy",
                description: "Show agent deploy settings",
                type: "Switch",
            },
            {
                label: "Show Agent Knowledge Base",
                name: "showAgentKnowledgeBase",
                description: "Show agent knowledge base",
                type: "Switch",
            }
        ],
        "Leads & Outbound Calling" : [
            {
                label: "Show Leads menu",
                name: "contact_allowed",
                description: "Show Leads menu",
                type: "Switch",
            },
            {
                label: "Show Automation",
                name: "automation_allowed",
                description: "Show outbound call Automation menu ",
                type: "Switch",
            },
            {
                label: "Show Campaigns",
                name: "campaign_allowed",
                description: "Show outbound call Campaigns menu",
                type: "Switch",
            },
        ],
        "Call Analytics":[
            {
                label: "Show Call Volume",
                name: "calls_volume_enabled",
                description: "Show Call Volume menu",
                type: "Switch",
            },
            {
                label: "Show Goal Conversion",
                name: "won_lost_enabled",
                description: "Show Goal Conversion menu",
                type: "Switch",
            },
            {
                label: "Show Timing Analysis",
                name: "duration_enabled",
                description: "Show Timing Analysis menu",
                type: "Switch",
            },
            {
                label: "Show Heat Map",
                name: "heat_map_enabled",
                description: "Show Heatmap menu",
                type: "Switch",
            },

            {
                label: "Show A/B Testing",
                name: "ab_testing_enabled",
                description: "Show A/B Testing menu",
                type: "Switch",
            },
            {
                label: "Show Call Details",
                name: "call_logs_enabled",
                description: "Show Call Details menu",
                type: "Switch",
            }
        ],
        "Account Settings" : [
            {
                label: "Show Users",
                name: "users_allowed",
                description: "Show Users menu",
                type: "Switch",
            },
            {
                label: "Show Phone Numbers",
                name: "create_number",
                description: "Show Phone Numbers menu",
                type: "Switch",
            },
            {
                label: "Show Custom Actions",
                name: "custom_actions_allowed",
                description: "Show Custom Actions menu",
                type: "Switch",
            },
            {
                label: "Show Web Widgets",
                name: "widgets_allowed",
                description: "Show Web Widgets menu ",
                type: "Switch",
            },
            {
                label: "Show Integrations",
                name: "integrations_allowed",
                description: "Show Integrations menu",
                type: "Switch",
            },
        ]
    }
};

export const permissionsHeader = [
    {
        header: "Permissions",
        description: "Use Calendar to schedule appointments.",
    },
];

export const subaccountAddedMessage = [
    ["Set Up Permissions", "Customize screen access and menu visibility for your client."],
    ["Enable Subscription Plan","Set up and activate plans to display for your clients."],
    ["Add Users","Add client users and allow them to log in to the app."],
    // ["Add Trial License", "A 7-day trial is enabled.Extend if needed."],
    // ["Choose Payment Plans", "Assign a subscription for this account."],
    // ["Invite Users", "Add client users and give them access."]
];

export const aiPromptLibrarySelectOptions = {
    provider: [
      { label: "Vapi", value: "vapi" },
      { label: "Retell", value: "retell" },
      // { label: "Bland", value: "bland" },
    ],
    voice: [
      { label: "Vapi", value: "vapi" },
    ],
    modal_name: {
      vapi: [
        { label: "gpt-4o-mini", value: "gpt-4o-mini" },
        { label: "gpt-4o", value: "gpt-4o" },
        { label: "chatgpt-4o-latest", value: "chatgpt-4o-latest" },
        { label: "gpt-4o-realtime-preview-2024-12-17", value: "gpt-4o-realtime-preview-2024-12-17" },
        { label: "gpt-4o-mini-realtime-preview-2024-12-17", value: "gpt-4o-mini-realtime-preview-2024-12-17" },
        { label: "o3-mini", value: "o3-mini" },
        { label: "o1-preview", value: "o1-preview" },
        { label: "o1-mini", value: "o1-mini" }
      ],
      retell: [
        { label: "gpt-4o", value: "gpt-4o" },
        { label: "gpt-4o-mini", value: "gpt-4o-mini" },
        { label: "gpt-4.1", value: "gpt-4.1" },
        { label: "gpt-4.1-mini", value: "gpt-4.1-mini" },
        { label: "gpt-4.1-nano", value: "gpt-4.1-nano" },
        { label: "claude-3.7-sonnet", value: "claude-3.7-sonnet" },
        { label: "claude-3.5-haiku", value: "claude-3.5-haiku" },
        { label: "gemini-2.0-flash", value: "gemini-2.0-flash" },
        { label: "gemini-2.0-flash-lite", value: "gemini-2.0-flash-lite" }
      ]
    },
    modal_provider: [
      { label: "Vapi", value: "vapi" },
    ],
    // client_msg: [
    //   { label: "Vapi", value: "vapi" },
    // ],
    // server_msg: [
    //   { label: "Vapi", value: "vapi" },
    // ],
    // idle_message: [
    //   { label: "Vapi", value: "vapi" },
    // ],
  };
  
export const aiPromptLibraryFields = [
    
    {
        section: "Provider",
        fields: [
            {
                label: "",
                name: "provider",
                type: "dropdown",
                description: "",
                placeholder: "Name Here",
                required: true,
                isDisabled: false,
                options : aiPromptLibrarySelectOptions["provider"],
            },
        ]
    },
    {
        section: "Agent Info",
        fields: [
            {
                label: "AI Agent Name",
                name: "Agent_Name",
                type: "text",
                description: "",
                placeholder: "Name Here",
                required: true,
                isDisabled: false,
            },
            {
                label: "Voice",
                name: "voice",
                type: "dropdown",
                description: "",
                placeholder: "Name Here",
                required: true,
                isDisabled: false,
                options : aiPromptLibrarySelectOptions["voice"],
            },
            // {
            //     label: "Client Messages",
            //     name: "client_msg",
            //     type: "dropdown",
            //     description: "",
            //     placeholder: "Name Here",
            //     required: true,
            //     isDisabled: false,
            //     options : aiPromptLibrarySelectOptions["client_msg"],
            // },
            // {
            //     label: "Server messages",
            //     name: "server_msg",
            //     type: "dropdown",
            //     description: "",
            //     placeholder: "Name Here",
            //     required: true,
            //     isDisabled: false,
            //     options : aiPromptLibrarySelectOptions["server_msg"],
            // },
            // {
            //     label: "idle messages",
            //     name: "idle_message",
            //     type: "dropdown",
            //     description: "",
            //     placeholder: "Name Here",
            //     required: true,
            //     isDisabled: false,
            //     options : aiPromptLibrarySelectOptions["idle_message"],
            // },   
        ],
    },
    {
        section: "Role",
        fields: [
            {
                label: "Task Prompt",
                name: "task_prompt",
                type: "textarea",
                description: "",
                placeholder: "Name Here",
                required: true,
                isDisabled: false,
            },
            {
                label: "First Message",
                name: "first_message",
                type: "text",
                description: "",
                placeholder: "Name Here",
                required: true,
                isDisabled: false,
            },
        ],
    },      
    {
        section: "Modal",
        fields: [
            {
                label: "Model name",
                name: "modal_name",
                type: "dropdown",
                description: "",
                placeholder: "Name Here",
                required: true,
                isDisabled: false,
                options : aiPromptLibrarySelectOptions["modal_name"],
            },
            {
                label: "Model provider",
                name: "modal_provider",
                type: "text",
                description: "",
                placeholder: "Name Here",
                required: true,
                isDisabled: false,
                options : aiPromptLibrarySelectOptions["modal_provider"],
            },
            {
                label: "Category",
                name: "category",
                type: "text",
                description: "",
                placeholder: "Name Here",
                required: true,
                isDisabled: false,
            },
            {
                label: "Services",
                name: "services",
                type: "text",
                description: "",
                placeholder: "Name Here",
                required: true,
                isDisabled: false,
            },
        ],
    },
    
    {
        section: "Transcriber",
        fields: [
            {
                label: "Transcription provider",
                name: "transcription_provider",
                type: "text",
                description: "",
                placeholder: "Name Here",
                required: true,
                isDisabled: false,
            },
            {
                label: "Transcription model",
                name: "transcription_modal",
                type: "text",
                description: "",
                placeholder: "Name Here",
                required: true,
                isDisabled: false,
            },
        ],
    },
];

export const libraryHideFields = {
    "vapi": [],
    "retell": ["server_msg", "idle_message","transcription_modal", "client_msg","transcription_provider","modal_provider"],
    "bland":[], 
}

export const ailibOptions = [
    {
        label : "View",
        value : "view",
        icon : <i class="fi fi-rr-eyes"></i>,
    },
    {
        label : "Update",
        value : "update",
        icon : <i class="fi fi-sc-pencil"></i>
    },
    {
        label : "Delete",
        value : "delete",
        icon : <i class="fi fi-rr-trash"></i>
    },
];